import { TypeaheadResult } from "@mirage/mosaics/SearchBarWithTypeahead/useConvertToTypeaheadResults";
import {
  ScoredUserQuery,
  typeahead,
} from "@mirage/service-typeahead-search/service/types";

export function isDefaultUserQueryResult<T extends TypeaheadResult>(
  mode: typeahead.Mode,
) {
  return (result: T): boolean => {
    return (
      (mode === typeahead.Mode.Ask &&
        result.scoredResult.type === typeahead.ResultType.AskUserQuery) ||
      result.scoredResult.type === typeahead.ResultType.SuggestedQuery ||
      result.scoredResult.type === typeahead.ResultType.WriteUserQuery ||
      result.scoredResult.type === typeahead.ResultType.OrganizeUserQuery
    );
  };
}

export function isUserQueryResult(
  result?: TypeaheadResult,
): result is TypeaheadResult {
  return (
    result?.scoredResult.type === typeahead.ResultType.AskUserQuery ||
    result?.scoredResult.type === typeahead.ResultType.SuggestedQuery ||
    result?.scoredResult.type === typeahead.ResultType.WriteUserQuery ||
    result?.scoredResult.type === typeahead.ResultType.OrganizeUserQuery
  );
}

export function isScoredUserQueryResult(
  result?: typeahead.ScoredResult,
): result is ScoredUserQuery {
  if (!result) return false;

  return (
    result.type === typeahead.ResultType.AskUserQuery ||
    result.type === typeahead.ResultType.SuggestedQuery ||
    result.type === typeahead.ResultType.WriteUserQuery ||
    result.type === typeahead.ResultType.OrganizeUserQuery
  );
}

export function hoistTypeaheadQueryIntoScoredUserQueryResult(
  result: ScoredUserQuery,
  typeaheadQuery: string,
): ScoredUserQuery {
  return {
    ...result,
    result: {
      ...result.result,
      // the current query is pulled from a ref to ensure that
      // we are always grabbing the latest query, not the query
      // at the time performSearch was invoked
      query: typeaheadQuery,
    },
  };
}
